import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload'
import { browserHistory } from 'react-router'

const columns = [
  { title: 'Session', prop: 'session_id', references: 'admin/sessions', referenceProp: 'long_name' },
  { title: 'Page', prop: 'page_id', references: 'admin/pages', referenceProp: 'title' },
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' }
]

const filters = [
  { name: 'Filter by session', prop: 'filters.session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name', enabled: true },
  { name: 'Filter by page', prop: 'filters.page_id', type: 'autocomplete', references: 'admin/pages', referenceProp: 'title', displayProp: 'title', enabled: true },
  { name: 'Filter by user', prop: 'filters.user_id', type: 'autocomplete', references: 'admin/users', referenceProp: 'name', displayProp: 'name', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const SessionRestrictedPages = (props) => (
  <List
    title='Session Restricted Pages'
    apiPath='admin/session_pages'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    customActions={[{
      handleTap: () => browserHistory.push(`${props.location.pathname}/import`),
      icon: <FileUploadIcon />,
      title: 'Bulk Import'
    }]}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default SessionRestrictedPages
